import React, { useState, useEffect, useMemo } from 'react'
import { useParams } from "react-router-dom"
import { useQuery } from '@tanstack/react-query'
import _ from 'lodash'
import { cn, queryTools, ELEMENTS } from "lib/utils"
import { useCompositeQuery } from "lib/hooks"
import { RenderLayout } from "lib/components"
import { PresetsChooser } from "./presets"
import { DisputePreviewChooser } from "."

export default function DisputePreview({
  mode="preview",
  subdomain,
  rp,
  // pdfRenderPkg,
  config,
  origin = "tb3"
}:{
  mode?:string
  subdomain?:string
  rp?:string
  // pdfRenderPkg?:any
  config?:any
  origin?:string
}){
  const { dspid } = useParams()

  const [ previewParams, setPreviewParams ] = useState<any>({ dispute: null, subdomain: null, rp: null }) 
  const [ renderPkg, setRenderPkg ] = useState<any>(null)
  const [ showPresets, setShowPresets ] = useState(false)
  // const [ renderPkg, setRenderPkg ] = useState<any>()

  const buildRenderPackage = () => {
    console.log(_CompositeData.payload)
    const mappedData = {
      ..._CompositeData.payload,
      elements: _CompositeData.payload.dispute.elements.map( (elem:any) => {
        const element:any = ELEMENTS.find( (e:any) => e.refstr === elem.refstr )
        if( element ) {
          return { ...elem, config: { ...element.config, structure: element.config.structure } }
        }
        return elem
      })
    }
    // console.log("Mapped Data", mappedData)
    setRenderPkg((prev:any) => ({ 
      ...prev, 
      ...mappedData, 
      subdomain: _CompositeData.payload.subdomain,
      rpid: _CompositeData.payload.clientdata.rp.Id,
      mode, 
      origin
    }))
  }

  const { data:_CompositeData } = useCompositeQuery({...previewParams})

  const runPreview = (preset:any, callbackFn?:any) => {
    if( preset && preset.subdomain && preset.rp ){
      console.log(preset.subdomain)
      setPreviewParams({
        dispute: dspid,
        subdomain: preset.subdomain,
        rp: preset.rp
      })
      if(callbackFn) callbackFn()
    }
  }

  useEffect(() => {
    if( !renderPkg && _CompositeData ){
      buildRenderPackage()
    }
  },[previewParams, _CompositeData, renderPkg])

  useEffect(() => {
    setPreviewParams( (prev:any) => ({
      dispute: dspid,
      subdomain: subdomain,
      rp: rp,
    })
  )},[dspid, subdomain, rp])

  if( !renderPkg || showPresets === true ) return <DisputePreviewChooser setPreviewParams={setPreviewParams}  /> //<DisputePreviewChooser setPreviewParams={setPreviewParams} />
  return (
    <div className="w-full h-full flex flex-col justify-start items-center mx-auto w-[1100px]">

      <div 
        onClick={() => setShowPresets(true)}
        className="w-full flex justify-end border-b border-solid border-teal-600 mt-3 mb-4 text-sm text-teal-700 uppercase pr-2 cursor-pointer"
      >
        <span>generate another preview</span>
      </div>

      {/* <PresetsChooser mode={mode} selectFn={runPreview} className="mb-4" /> */}

      { renderPkg !== undefined && (
        <div 
          className={cn(
            "w-full flex flex-col justify-start items-center bg-white text-gray-950 px-6 py-2 mt-5",
            mode === "preview" && "overflow-y-auto scrollbar"
          )}
          style={{
            width: mode === "pdf" ? `${config.width}px` : mode === "preview" ? "100%" : "100%",
            height: mode === "pdf" ? `${config.height}px` : mode === "preview" ? "calc(100vh - 16rem)" : "100%",
          }}
        > 
          <RenderLayout 
            mode={mode} 
            layout={renderPkg?.layout?.config.structure}
            renderPkg={renderPkg} 
          />
        </div>
      )}
    </div>
  )
}